import { notEmpty } from '@festina-life/core'
import { useMemo } from 'react'

import type { TemplateVersionInfo } from '../../types/templateModel'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'

export const useTemplateOperationsWithVersionInfo = (
  versions: TemplateVersionInfo[],
) => {
  const { applicationTemplates: applicationTemplateOperations } =
    useApplicationViewOperationsContext()

  return useMemo(
    () =>
      versions
        .map((forVersion) => {
          const indexedOperation = applicationTemplateOperations?.get(
            forVersion.identifier,
          )

          const createOperation = indexedOperation?.operations.find(
            (operation) =>
              operation.internalOperation.operationKey ===
              forVersion.operationKey,
          )

          if (!createOperation && !forVersion.isMissing) {
            throw new Error(
              `Could not find an operation for the template version ${forVersion.identifier} with operation key ${forVersion.operationKey}`,
            )
          }

          return createOperation?.internalOperation
            ? { ...createOperation?.internalOperation, versionInfo: forVersion }
            : null
        })
        .filter(notEmpty),
    [applicationTemplateOperations, versions],
  )
}
